export default __webpack_public_path__ + "static/media/color-wheel.32ebbc69.svg";